export enum EvidenceSearchOption {
  Npi = "NPI",
  Xid = "Xid",
  Address = "Address"
}